import type { useSocketHandlers } from './useSocketHandlers'

export type SocketHandlerMap = ReturnType<typeof useSocketHandlers>

/**
 * Socket message type handler mapping
 * Maps message types to their corresponding handler functions
 */
export const createSocketHandlerMap = (handlers: SocketHandlerMap) => ({
  auth_success: handlers.handleAuthSuccess,
  message_history: handlers.handleMessageHistory,
  auth_error: handlers.handleAuthError,
  auth_failed: handlers.handleAuthFailed,
  response: handlers.handleResponse,
  user_message: handlers.handleUserMessage,
  notification: handlers.handleNotification,
  review_prompt: handlers.handleReviewPrompt,
  error: handlers.handleError,
  ask_user: handlers.handleAskUser,
  end_of_stream: handlers.handleEndOfStream,
  section_select_ack: handlers.handleSectionSelectAck,
  show_form: handlers.handleShowForm,
  component: handlers.handleComponent,
  article: handlers.handleArticle,
  form_submission_ack: handlers.handleFormSubmissionAck,
  form_submission_error: handlers.handleFormSubmissionError,
  guest_info_submission_ack: handlers.handleGuestInfoSubmissionAck,
  guest_info_submission_error: handlers.handleGuestInfoSubmissionError,
  'new-operator-message': handlers.handleNewOperatorMessage,
  info: handlers.handleInfo,
  transfer: handlers.handleTransfer,
  session_update: handlers.handleSessionUpdate,
  operator_message: handlers.handleOperatorMessage,
  session_state: handlers.handleSessionState,
  'upload_file.success': handlers.handleUploadFileSuccess,
  'upload_file.error': handlers.handleUploadFileError,
  new_topic_success: handlers.handleNewTopicSuccess,
  new_topic_error: handlers.handleNewTopicError,
  typing_indicator: handlers.handleTypingIndicator,
  end: handlers.handleEnd,
  session_closed: handlers.handleSessionClosed,
  tickets_list: handlers.handleTicketsList,
  ticket_history: handlers.handleTicketHistory,
  ticket_follow_up_error: handlers.handleTicketFollowUpError,
  ticket_history_error: handlers.handleTicketHistoryError,
  ticket_updates: handlers.handleTicketUpdates
})

export type MessageType = keyof ReturnType<typeof createSocketHandlerMap>
